// Prevent <input type="number"> from changing its value when the user scrolls
// the mouse wheel over it. The browser's default behaviour steps the value
// while a number input is focused, which silently corrupts forms (cost cards,
// salary tables, quote inputs) whenever someone scrolls past a focused field.
//
// We solve it once at the document level by blurring the focused number input
// on wheel. The wheel event itself is not preventDefault'd, so the page still
// scrolls; the value just doesn't change because the input is no longer the
// focused element by the time the browser processes the step.

if (typeof document !== "undefined") {
  document.addEventListener(
    "wheel",
    () => {
      const a = document.activeElement;
      if (a && a.tagName === "INPUT" && a.type === "number") {
        a.blur();
      }
    },
    { passive: true }
  );
}
